import React, { useEffect, useState } from "react";
import {
  getAbonnements,
  deleteAbonnement,
  getMembershipTypes,
  getAbonnementsUsers,
  getAbonnement,
} from "../Util/API";
import { abonnementsActions, membershipTypeActions, useSelector } from "inbooma-api";
import t from "../../../helpers/t";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import Paginator from "../../../components/paginator";
import Loader from "../../../components/Loader";
import { Biscuit, getAllUrlParams } from "../../../../utils";
import moment from "moment";
import { $, _ } from "../../../../../vendor";
import AbonnementsSidebar from "./AbonnementsSidebar";
import AbonnementsList from "./AbonnementsList";
import Notification from "../../../components/Notification";
import ItemView from "./ItemView";
import MultipleUsersDialog from "./MultipleUsersDialog";
const AbonnementsView = (props: any) => {
  const { name, dispatch, params, returnPath, rbac, submenuitems, createAccessBar, states } = props;
  const currentUrl: any = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const allUrlParamsClone = { ...allUrlParams };
  const [abonnementsPending, setAbonnementsPending] = useState(false);
  const [abonnementsUsersPending, setAbonnementsUsersPending] = useState(false);
  const [membershipTypesPending, setMembershipTypesPending] = useState(false);
  const [membershipTypes, setMembershipTypes]: any = useState([]);
  const [abonnement, setAbonnement] = useState(null);
  const [listView, setListView] = useState(false);
  const [abonnementPending, setAbonnementPending] = useState(false);
  const [deleteAbonnementPending, setDeleteAbonnementPending] = useState(false);
  const [add, setAdd] = useState(params !== null && params[0] === "add");
  const _abonnements = useSelector((state: any) => state.abonnements_data.getAbonnements);
  const _abonnementsUsers = useSelector(
    (state: any) => state.abonnements_users_data.getAbonnementsUsers,
  );
  const _membershipTypes = useSelector((state: any) => state.membership_types_data.membershipTypes);
  const _abonnement = useSelector((state: any) => state.abonnements_data.getAbonnement);
  const _deleteAbonnement = useSelector((state: any) => state.abonnements_data.deleteAbonnement);
  const [initialized, setInitialized] = useState(false);
  const [filter, setFilter]: any = useState({
    find: "full",
    ...allUrlParams,
  });
  const [resetFilter, setResetFilter] = useState(false);
  const [sort, setSort]: any = useState({
    sort: allUrlParamsClone?.sort !== undefined ? allUrlParamsClone.sort : "name",
    direction: allUrlParamsClone?.direction !== undefined ? allUrlParamsClone.direction : "asc",
  });
  const _queryState = {
    timeStamp: 0,
    value: "",
  };
  const paginationLimit = 100;
  const [pagination, setPagination]: any = useState({
    has_next_page: false,
    current_page: 1,
  });

  useEffect(() => {
    if (!states.add && !states.edit) {
      getAbonnements({
        dispatch: dispatch,
        filter: filter,
      });
      setAbonnementsPending(true);
    }
    getMembershipTypes({
      dispatch: dispatch,
      filter: filter,
    });
    setMembershipTypesPending(true);
    if (states.edit && states.index !== null) {
      getAbonnement({
        dispatch: dispatch,
        id: states.index,
      });
      setAbonnementPending(true);
    }
  }, []);

  useEffect(() => {
    if (!abonnementsPending || _abonnements.success === "") {
      return;
    }
    if (_abonnements.success === true) {
      setPagination(_abonnements.pagination);
    }
    setAbonnementsPending(false);
  }, [_abonnements]);

  useEffect(() => {
    console.log(_abonnementsUsers);
    if (!abonnementsUsersPending || _abonnementsUsers.success === "") {
      return;
    }
    if (_abonnementsUsers.success === true) {
    }
    setAbonnementsUsersPending(false);
    setListView(true);
  }, [_abonnementsUsers]);

  useEffect(() => {
    if (!deleteAbonnementPending || _deleteAbonnement.success === "") {
      return;
    }
    if (_deleteAbonnement.success === true) {
    }
    setDeleteAbonnementPending(false);
  }, [_deleteAbonnement]);

  useEffect(() => {
    if (!abonnementPending || _abonnement.success === "") {
      return;
    }
    if (_abonnement.success === true) {
    }
    setAbonnementPending(false);
  }, [_abonnement]);

  useEffect(() => {
    if (!membershipTypesPending || _membershipTypes.success === "") {
      return;
    }
    if (_membershipTypes.success === true) {
      let temp = [];
      temp.push({ id: null, name: t("switch") });
      _membershipTypes.data.map((item: any) => {
        temp.push({ id: item.id, name: item.name });
      });
      setMembershipTypes(temp);
    }
    setMembershipTypesPending(false);
    setInitialized(true);
  }, [_membershipTypes]);

  const loadNextPage = () => {
    // if (!pagination.has_next_page) return;

    setAbonnementsPending(true);
    // request next page
    getAbonnements({
      filter: {
        ...filter,
        page: pagination.current_page + 1,
        limit: pagination.limit,
      },
      dispatch: dispatch,
    });
  };
  const filterChangedHandle = (filter: any, sorts: null | any = null) => {
    let requestFilter: any = { ...filter };
    if (sorts === null) {
      sorts = sort;
    } else {
      setSort(sorts);
    }
    requestFilter.sort = sorts.sort;
    requestFilter.direction = sorts.direction;
    if (typeof filter.limit !== "undefined") {
      requestFilter.limit = filter.limit;
      if (typeof requestFilter.page !== "undefined") {
        delete requestFilter.page;
      }
    } else {
      requestFilter.limit = paginationLimit;
      requestFilter.page = 1;
    }
    getAbonnements({
      dispatch: dispatch,
      filter: requestFilter,
    });
    setAbonnementsPending(true);
    setFilter(filter);
  };
  const searchBarHandler = (ev: any) => {
    let query: string;
    if (typeof ev.target !== "undefined") {
      query = ev.target.value.toLowerCase();
    } else {
      query = "";
    }

    const minLength: number = 1;
    if (query.length >= minLength) {
      // work user search only for values bigger or equal to the minimum length
      let standardFilter = {
        sort: "description",
        direction: "asc",
        page: 1,
        find: "full",
        limit: paginationLimit,
        ...allUrlParams,
      };
      if (query !== "") {
        searchParams.set("q", query);
      }
      const newRelativePathQuery: string = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
      let filterA: any = standardFilter;
      setResetFilter(true);
      setTimeout(function () {
        let diff: number = Number(moment().format("x")) - _queryState.timeStamp;

        if (diff > 700 && _queryState.value === query) {
          // no changes after the last 700 ms -> user finished input -> start request
          filterChangedHandle({
            ...filterA,
            q: query,
          });
        }
      }, 800);
    } else if (filter.q !== undefined) {
      // reset filter when query was active
      let clone: any = { ...filter };
      delete clone.q;
      filterChangedHandle(clone);
    }
    _queryState.timeStamp = Number(moment().format("x"));
    _queryState.value = query;
  };

  const onSortChangedHandle = (ev: any) => {
    const el: any = ev.currentTarget;
    const sortKey: any = el.getAttribute("data-inb-val"),
      direction: any = el.getAttribute("data-inb-direction"),
      isOppositeElement: boolean = direction === null && el.classList.contains("is-active"),
      newDirection: string = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter: any;
      if (typeof filter.limit !== "undefined") {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
        };
      } else {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
          limit: paginationLimit,
          page: 1,
        };
      }

      setSort({
        sort: sortKey,
        direction: direction,
      });

      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key) {
        key["classList"].remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const getList = (abonnement: any) => {
    getAbonnementsUsers({
      dispatch: dispatch,
      filter: {
        abonnement_id: abonnement.id,
      },
    });
    setAbonnementsUsersPending(true);
  };
  const closeList = (e: any) => {
    setAbonnement(null);
    setListView(false);
  };

  const tabs: any[] = [
    {
      name: t("description", null, "capital"),
      smallWidth: 3,
      mediumWidth: 3,
      title: t("sort_by_${a}", { a: t("description") }, "capital"),
      canSort: true,
      preselected: true,
      sort: {
        direction: sort.direction,
        data_inb_val: sort.sort,
      },
    },
    {
      name: t("interval", null, "capital"),
      smallWidth: 2,
      mediumWidth: 2,
      title: t("interval", null, "capital"),
      canSort: false,
      sort: {
        direction: sort.direction,
        data_inb_val: sort.sort,
      },
    },
    {
      name: t("duration", null, "capital"),
      mediumWidth: 2,
      smallWidth: 2,
      title: t("duration", null, "capital"),
      canSort: true,
      sort: {
        direction: sort.direction,
        data_inb_val: sort.sort,
      },
    },
    {
      name: t("minimal duration", null, "capital"),
      smallWidth: 2,
      mediumWidth: 2,
      title: t("minimal duration", null, "capital"),
      canSort: true,
      sort: {
        direction: sort.direction,
        data_inb_val: sort.sort,
      },
    },
    {
      name: t("amount", null, "capital"),
      smallWidth: 2,
      mediumWidth: 2,
      title: t("amount", null, "capital"),
      canSort: true,
      sort: {
        direction: sort.direction,
        data_inb_val: sort.sort,
      },
    },
  ];
  return (
    <>
      {" "}
      <AbonnementsSidebar
        dispatch={dispatch}
        heading={t("abonnements", null, "capital")}
        filterChangedHandle={filterChangedHandle}
        filter={filter}
        setFilter={setFilter}
        resetFilter={resetFilter}
        setResetFilter={setResetFilter}
        rbac={rbac}
        sort={sort}
        setAdd={setAdd}
        setSort={setSort}
        initialized={initialized}
        /*summary={summary}
        summaryPending={summaryPending}*/
      />
      <div id="inb-c-main" className="columns">
        {createAccessBar && (
          <InboomaSubmenu
            tabs={submenuitems}
            smallOnlyTitle={t(name, null, "capital")}
            extraClasses={"sticky-top"}
            searchbar={true}
            searchbarPlaceholder={t("abonnement") + " / " + t("id", null, "capital")}
            searchbarHandler={searchBarHandler}
            pagination={pagination}
            itemsCountPerPage={paginationLimit}
            pageRangeDisplayed={5}
            onChange={loadNextPage}
            itemLength={_abonnements.length}
          />
        )}

        <SortNav
          tabs={tabs}
          extraClasses={"sticky-top-sortbar"}
          listStyle="tight"
          handler={onSortChangedHandle}
        />

        {/* {initialized && !contingentsPending && _contingents.length > 0 && typeof pagination !== 'undefined' &&
                  <Paginator
                      pagination={pagination}
                      itemsCountPerPage={paginationLimit}
                      pageRangeDisplayed={5}
                      onChange={loadNextPage}
                  />}*/}
        <div className="off-canvas-wrapper">
          {_abonnements?.data.length > 0 && initialized && (
            <AbonnementsList
              abonnements={_abonnements.data}
              abonnement={_abonnement?.data}
              getList={getList}
              dispatch={dispatch}
              filterChangedHandle={filterChangedHandle}
              filter={filter}
              setFilter={setFilter}
              sort={sort}
              setSort={setSort}
              params={params}
              rbac={rbac}
              deleteAbonnement={deleteAbonnement}
            />
          )}
          {((typeof _abonnements?.data !== "undefined" && _abonnements?.data.length < 1) ||
            typeof _abonnements?.data === "undefined") && (
            <>
              <div
                id="inb-app-collection-empty"
                className="inb-announcement"
                style={{ minHeight: "1150px" }}
              >
                <div className="inb-image-box">
                  <img alt="No Data" src={"assets/img/no_data.svg"} />
                </div>
                <h3>{t("app_msg_collection_empty")}</h3>
                <p>{t("app_msg_collection_empty_body")}</p>
              </div>
            </>
          )}
          {initialized &&
            !abonnementsPending &&
            _abonnements.length > 0 &&
            typeof pagination !== "undefined" && (
              <Paginator
                pagination={pagination}
                itemsCountPerPage={paginationLimit}
                pageRangeDisplayed={5}
                onChange={loadNextPage}
              />
            )}
          {abonnementsPending && <Loader mediumWidth={2} smallWidth={4} subLoaders={5} />}
        </div>
      </div>
      {initialized &&
        (states.add || (states.edit && states.index !== null && !abonnementPending)) && (
          <ItemView
            dispatch={dispatch}
            abonnementsActions={abonnementsActions}
            abo={_abonnement?.data}
            membershipTypes={membershipTypes}
            params={params}
            requestPath={returnPath}
            showNotification={Notification}
            setFilter={setFilter}
            filter={filter}
            currentUrl={new URL(window.location.href)}
          />
        )}
      {listView && !abonnementsUsersPending && (
        <MultipleUsersDialog
          abonnement={{ abonnements_users: _abonnementsUsers.data }}
          toggleMultipleUsers={listView}
          handleCloseMultipleUsersDialog={closeList}
        />
      )}
    </>
  );
};
export default AbonnementsView;
